"use client"

import { useRouter } from "next/navigation";
import { useAuthStore } from "../../store/auth";
import { useEffect } from "react";


const Home = () => {
  const router = useRouter()
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn)

  useEffect(() => {
    router.replace(isLoggedIn ? "/dashboard" : "/login")
  })

  return null
}

export default Home
